import { render } from "./RelatedShows.vue?vue&type=template&id=7b1cf940&scoped=true"
import script from "./RelatedShows.vue?vue&type=script&lang=js"
export * from "./RelatedShows.vue?vue&type=script&lang=js"

import "./RelatedShows.vue?vue&type=style&index=0&id=7b1cf940&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b1cf940"]])

export default __exports__